// extracted by mini-css-extract-plugin
export var avatarContainer = "_6u-0";
export var avatarTypingWave = "_6u-i";
export var gray = "_6u-f";
export var green = "_6u-c";
export var icon = "_6u-9";
export var image = "_6u-1";
export var lg = "_6u-6";
export var md = "_6u-5";
export var presenceDot = "_6u-b";
export var red = "_6u-d";
export var sm = "_6u-4";
export var status = "_6u-a";
export var typingDot = "_6u-h";
export var typingPill = "_6u-g";
export var xl = "_6u-7";
export var xs = "_6u-3";
export var xxl = "_6u-8";
export var xxs = "_6u-2";
export var yellow = "_6u-e";